export const MEDIA_BASE_URL =
  "https://personal-driver-s3.s3.us-east-2.amazonaws.com/";

export function buildMediaUrl(fileKey) {
  if (!fileKey) {
    return "";
  }
  if (fileKey.startsWith("http://") || fileKey.startsWith("https://")) {
    return fileKey;
  }
  return `${MEDIA_BASE_URL}${fileKey}`;
}

export function formatDateForInput(dateValue) {
  if (!dateValue) {
    return "";
  }
  if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  }
  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(dateValue).split("T")[0];
  }
  return parsedDate.toISOString().split("T")[0];
}
